import React from 'react'
import _ from 'lodash'
import { withRouter } from 'react-router-dom'

import { fetchContributors } from '../../../modules/portal-remote/portalService'
import { toast } from 'react-toastify'
import ContributorListItem from '../contributor-list/ContributorListItem'
import Field from '../../views/widgets/Field'

class GeneralInfoFormContributorContainer extends React.Component {
  state = {
    contributors: [],
    currentContributors: [],
    currentContributorID: undefined,
  }

  async componentDidMount() {
    try {
      const contributors = await fetchContributors()
      this.setState({
        contributors: _.isEmpty(this.props.contributors)
          ? contributors
          : _.reject(contributors, contributor =>
              _.some(this.props.contributors, { _id: contributor._id }),
            ),
        currentContributors: this.props.contributors || [],
      })
    } catch (error) {
      toast.error(error.message)
    }
  }

  handleContributorIDChange = e => {
    const currentContributorID = e.target.value
    this.setState({ currentContributorID })
  }

  findContributorByID = contributorID => {
    return _.find(this.state.contributors, {
      _id: contributorID,
    })
  }

  handleDelete = contributor => {
    this.setState(
      prevState => ({
        contributors: [...prevState.contributors, contributor],
        currentContributors: _.reject(prevState.currentContributors, {
          _id: contributor._id,
        }),
      }),
      this.handleContributorChange,
    )
  }

  handleAdd = () => {
    const contributorID =
      this.state.currentContributorID ||
      _.chain(this.state.contributors)
        .head()
        .get('_id')
        .value()

    const contributor = this.findContributorByID(contributorID)

    this.setState(
      prevState => ({
        contributors: _.reject(prevState.contributors, {
          _id: contributorID,
        }),
        currentContributors: [contributor, ...prevState.currentContributors],
      }),
      this.handleContributorChange,
    )
  }

  handleContributorChange = () => {
    if (this.props.onContributorChange) {
      this.props.onContributorChange(this.state.currentContributors)
    }
  }

  handleGotoCreateContributor = () => {
    if (
      window.confirm(
        'ตรวจสอบให้แน่ใจว่า ได้กด บันทึก เรียบร้อยแล้ว ก่อนไปหน้าสร้าง ผู้เขียน',
      )
    ) {
      this.props.history.push('/contributor')
    }
  }

  render() {
    const language = this.props.language || 'th'

    return (
      <div>
        <Field label={`เลือกผู้เขียน`}>
          {_.isEmpty(this.state.contributors) ? (
            <div>
              <div
                className="button is-info"
                to="/contributor"
                onClick={this.handleGotoCreateContributor}
              >
                ไม่มีผู้เขียนให้เลือกแล้ว, กดเพื่อไปหน้า สร้างผู้เขียน
              </div>
            </div>
          ) : (
            <React.Fragment>
              <div class="field is-grouped">
                <div class="control is-expanded">
                  <div className="select is-fullwidth">
                    <select
                      onChange={this.handleContributorIDChange}
                      onBlur={this.handleContributorIDChange}
                    >
                      {_.map(this.state.contributors, contributor => (
                        <option key={contributor._id} value={contributor._id}>
                          {_.get(contributor, `name.${language}`)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div class="control">
                  <div className="button is-primary" onClick={this.handleAdd}>
                    เพิ่ม
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
        </Field>
        <div className="section">
          {!_.isEmpty(this.state.currentContributors) ? (
            _.map(this.state.currentContributors, contributor => (
              <ContributorListItem
                key={contributor._id}
                contributor={contributor}
                onDelete={this.handleDelete}
              />
            ))
          ) : (
            <div className="heading has-text-centered">empty contributors</div>
          )}
        </div>
      </div>
    )
  }
}

export default withRouter(GeneralInfoFormContributorContainer)



// WEBPACK FOOTER //
// ./src/components/templates/general-info/GeneralInfoFormContributorContainer.js